/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-02 06:14:11
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import type { CustomSortingState, CustomSortingAction } from 'stores/flow-type/custom-sorting.type';
import { SORT_TYPES_LABEL } from 'src/constants/custom-sorting';

import {
  GET_AVAILABLE_SORT_TYPES_REQUEST,
  GET_AVAILABLE_SORT_TYPES_SUCCESS,
  GET_AVAILABLE_SORT_TYPES_FAILURE,
  GET_CUSTOM_SORTING_REQUEST,
  GET_CUSTOM_SORTING_SUCCESS,
  GET_CUSTOM_SORTING_FAILURE,
  UPDATE_CUSTOM_SORTING_REQUEST,
  UPDATE_CUSTOM_SORTING_SUCCESS,
  UPDATE_CUSTOM_SORTING_FAILURE
} from 'stores/flow-type/custom-sorting.type';

const initialState: CustomSortingState = {
  getSortTypesLoading: false,
  getSortTypesSuccess: false,
  loading: false,
  saving: false,
  saveSuccess: false,
  error: undefined,
  sortByOptions: [],
  scheduleSyncIn: 0,
  scheduleSyncAfter: 0,
  waitSyncAt: 0,
  sortTypes: []
};

const customSortingReducers = (
  state: CustomSortingState = initialState,
  action: CustomSortingAction
) => {
  switch (action.type) {
    case GET_AVAILABLE_SORT_TYPES_REQUEST:
      return { ...state, getSortTypesLoading: true, getSortTypesSuccess: false };

    case GET_AVAILABLE_SORT_TYPES_SUCCESS: {
      const { data = [] } = action.payload.data;
      const { i18n } = action.payload;
      const sortTypes = _.map(data, item => {
        const { type, name = '' } = item;
        let label = '';
        if (item.type === 'metafield') {
          label = name.charAt(0).toUpperCase() + name.slice(1);
        } else {
          const labelKey = SORT_TYPES_LABEL[item.name];
          if (labelKey) {
            label = i18n.translate(labelKey);
          }
        }
        return {
          type,
          value: name,
          label
        };
      });
      return {
        ...state,
        getSortTypesLoading: false,
        getSortTypesSuccess: true,
        error: undefined,
        sortTypes
      };
    }
    case GET_AVAILABLE_SORT_TYPES_FAILURE:
      return {
        ...state,
        getSortTypesLoading: false,
        getSortTypesSuccess: false,
        error: action.payload
      };
    case GET_CUSTOM_SORTING_REQUEST:
      return { ...state, loading: true, waitSyncAt: 0, scheduleSyncIn: 0, scheduleSyncAfter: 0 };

    case GET_CUSTOM_SORTING_SUCCESS: {
      const { data = {} } = action.payload;
      const { data: sortByOptions, waitSyncAt, scheduleSyncIn, scheduleSyncAfter } = data;

      return {
        ...state,
        loading: false,
        error: undefined,
        sortByOptions,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      };
    }
    case GET_CUSTOM_SORTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_CUSTOM_SORTING_REQUEST:
      return {
        ...state,
        saving: true,
        saveSuccess: false,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_CUSTOM_SORTING_SUCCESS: {
      const { data = {} } = action.payload;
      const { data: sortByOptions, waitSyncAt, scheduleSyncIn, scheduleSyncAfter } = data;

      return {
        ...state,
        saving: false,
        error: undefined,
        saveSuccess: true,
        sortByOptions,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      };
    }

    case UPDATE_CUSTOM_SORTING_FAILURE:
      return {
        ...state,
        saving: false,
        saveSuccess: false,
        error: action.payload,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    default:
      return state;
  }
};

export default customSortingReducers;
